import { Directive, inject } from '@angular/core';
import { LOCAL_STORAGE } from '../../consts/local-storage.injection-token';
import { WINDOW } from '../../consts/window.injection-token';
import { StorageService } from '../../services/storage.service';
import { AuthState } from '../../types/auth-state';

@Directive({
    selector: '[appMaintenanceCredentialsStorage]',
  exportAs: 'appCredentialsStorage'
})
export class MaintenanceCredentialsStorageDirective {

  private readonly storageService = inject(StorageService);
  private readonly localStorage = inject<Storage>(LOCAL_STORAGE);
  private readonly window = inject<Window>(WINDOW);

  public static getPossibleAction(hasSnapshot: boolean, displayAuthStatus: AuthState['status']) {
    if (hasSnapshot) {
      return 'restore';
    }
    if (displayAuthStatus === 'authorized') {
      return 'store';
    }
    return;
  }

  public onStoreClick(): void {
    const data = this.getPlatformAuthData();
    if (!data) {
      return;
    }
    this.storageService.data.devAuthSnapshot = {
      state: this.storageService.data.authState!,
      platform: data
    };
    this.storageService.data.authState = null;
    this.clearPlatformAuthData();
    this.window.location = '/';
  }

  public onRestoreClick(): void {
    const snapshotData = this.storageService.data.devAuthSnapshot!;
    this.storageService.data.authState = snapshotData.state;
    this.restorePlatformAuthData(snapshotData.platform);
    this.storageService.data.devAuthSnapshot = null;
    this.window.location = '/';
  }

  private getPlatformAuthData(): string | null {
    const dataKey = this.getPlatformAuthDataKey();
    if (!dataKey) {
      return null;
    }
    return this.localStorage.getItem(dataKey);
  }

  private clearPlatformAuthData(): void {
    const dataKey = this.getPlatformAuthDataKey();
    if (!dataKey) {
      return;
    }
    this.localStorage.removeItem(dataKey);
  }

  private restorePlatformAuthData(data: string): void {
    const dataKey = this.getPlatformAuthDataKey();
    if (!dataKey) {
      return;
    }
    this.localStorage.setItem(dataKey, data);
  }

  private getPlatformAuthDataKey(): string | undefined {
    return Object.keys(this.localStorage)
      .find(key => key.endsWith('storedData'));
  }

}
